import { z } from 'zod';

const objectDigestIntervalSchema = z
  .preprocess(
    (value) => (value === '' ? undefined : value),
    z.coerce.number().min(1).max(24).optional()
  )
  .optional();

export const customerFormSchema = z.object({
  name: z.string().min(1),
  companyType: z.string().optional(),
  industry: z.string().optional(),
  website: z.string().url().optional().or(z.literal('')),
  userQuota: z.coerce.number(),
  customerType: z.enum(['customer', 'heli-provider']).optional(),
  objectDigestEnabled: z.boolean().optional(),
  objectDigestRecipients: z.array(z.string()).optional(),
  objectDigestInterval: objectDigestIntervalSchema,
});
